import { Link } from "react-router-dom";
import Image from "../Image/Image";
import { useEffect, useState } from "react";

const PostListItem = (props: {
  id?: string;
  header?: string;
  abstract?: string;
  category?: string;
  categoryLink?: string;
  author?: string;
  authorLink?: string;
  createdAt?: string;
  coverImageURL?: string;
  coverImageWidth?: string;
  coverImageHeight?: string;
  coverImageClassName?: string;
  containerClassName?: string;
}) => {
  const baseCoverImageClassName: string =
    "post-list-image rounded-xl object-cover";
  const baseContainerClassName: string =
    "flex flex-col xl:flex-row xl:items-center gap-4 mb-8 bg-white rounded-3xl py-5 px-4 shadow-lg";
  const mobileChars: number = 180;
  const tabletChars: number = 200;
  const desktopChars: number = 230;

  const getCharLimit = () => {
    if (window.innerWidth < 640) return mobileChars;
    if (window.innerWidth >= 640 && window.innerWidth < 1024)
      return tabletChars;
    if (window.innerWidth >= 1024) return desktopChars;
    return 150;
  };

  const [charLimit, setCharLimit] = useState<number>(getCharLimit());

  useEffect(() => {
    const handleResize = () => setCharLimit(getCharLimit());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={props.containerClassName || baseContainerClassName}
      style={{
        minWidth: "12rem",
      }}
    >
      {/* Image div */}
      {props.coverImageURL && (
        <div className="md:hidden xl:block xl:w-1/6">
          <Image
            src={props.coverImageURL || ""}
            width={props.coverImageWidth || "250"}
            height={props.coverImageHeight || "250"}
            alt="Post cover image"
            className={props.coverImageClassName || baseCoverImageClassName}
          />
        </div>
      )}
      {/* Details */}
      <div className="flex flex-col gap-4 xl:w-5/6">
        <Link to={`/blog/posts/${props.id}`} className="text-3xl font-semibold">
          {props.header}
        </Link>
        <div className="flex flex-col items-start gap-2 text-gray-400 text-sm">
          <span className="flex gap-1">
            ავტორი: {props.author}
            {/* <Link to={`/users/${props.authorLink}`} className="text-blue-800">
              {props.author}
            </Link> */}
          </span>
          <span className="flex gap-1">
            კატეგორია:
            <Link
              to={`/blog/posts?category=${props.category}`}
              className="text-blue-800"
            >
              {props.category}
            </Link>
          </span>
          <span className="flex gap-1">
            თარიღი: {props.createdAt?.slice(0, 10)}
          </span>
        </div>
        {props.abstract && (
          <p className="text-m">
            {props.abstract.length > charLimit
              ? props.abstract.slice(0, charLimit) + "..."
              : props.abstract}
          </p>
        )}
        <Link
          to={`/blog/posts/${props.id}`}
          className="underline text-blue-800 text-m"
        >
          დეტალები
        </Link>
      </div>
    </div>
  );
};

export default PostListItem;
